<div class="min-w-[450px]">
  <div class="flex items-center">
    <twaice-fe-svg-icon name="binary-tree-2" source="tabler" class="mr-8" size="16px" />
    <span class="text-base font-semibold">{{ storageLevel.System | storageLevelToCustomerLevelName: true : 1 }} Metadata</span>
  </div>

  <nz-divider class="my-16" />

  <div class="flex flex-col gap-16">
    <div>
      <span class="block mb-4 font-semibold">General</span>
      <div class="flex items-center gap-40 overflow-x-auto">
        <div class="flex flex-col justify-start">
          <p class="font-normal text-sm leading-base text-tertiary-text m-0">Location</p>
          <p class="text-base font-normal leading-lg text-primary-text">{{ storageLocation }}</p>
        </div>

        <div class="flex flex-col justify-start">
          <p class="font-normal text-sm leading-base text-tertiary-text m-0">CoD</p>
          <p class="text-base font-normal leading-lg text-primary-text">
            {{ bessMetadata?.commercialOperationDate ?? '--' }}
          </p>
        </div>
      </div>
    </div>

    <div>
      <span class="block mb-4 font-semibold">Energy setup</span>
      <div class="flex items-center gap-40 overflow-x-auto">
        <div class="flex flex-col justify-start">
          <p class="font-normal text-sm leading-base text-tertiary-text m-0">Nameplate Capacity</p>
          <p class="text-base font-normal leading-lg text-primary-text">
            {{
              bessMetadata?.nameplateEnergyCapacityMwh
                ? (bessMetadata?.nameplateEnergyCapacityMwh | number: '1.0-0') + ' MWh'
                : '--'
            }}
          </p>
        </div>

        <div class="flex flex-col justify-start">
          <p class="font-normal text-sm leading-base text-tertiary-text m-0">Nameplate Power</p>
          <p class="text-base font-normal leading-lg text-primary-text">
            {{ bessMetadata?.nameplatePowerMw ? (bessMetadata?.nameplatePowerMw | number: '1.0-0') + ' MW' : '--' }}
          </p>
        </div>

        <div class="flex flex-col justify-start">
          <p class="font-normal text-sm leading-base text-tertiary-text m-0">Chemistry</p>
          <p class="text-base font-normal leading-lg text-primary-text">
            {{ topology?.chemistry || '--' }}
          </p>
        </div>
      </div>
    </div>

    <div *ngIf="getComponentCountOnLevels({ type: 'electrical' }).length > 0">
      <span class="block mb-4 font-semibold">Electrical Anatomy</span>
      <div class="flex items-center gap-40 overflow-x-auto">
        <div class="flex flex-col justify-start" *ngFor="let container of getComponentCountOnLevels({ type: 'electrical' })">
          <p class="font-normal text-sm leading-base text-tertiary-text m-0 whitespace-nowrap">
            {{ container.levelBk | storageLevelToCustomerLevelName: true : container.count }}
          </p>

          <twaice-fe-data-display
            class="text-base font-normal leading-lg text-primary-text"
            [value]="container.count"
            numberFormat="1.0-0"
            notAvailableText="-"
            data-test="nav-menu-container-item-value"
          ></twaice-fe-data-display>
        </div>
      </div>
    </div>

    <div *ngIf="getComponentCountOnLevels({ type: 'physical' }).length > 0">
      <span class="block mb-4 font-semibold">Physical Anatomy</span>
      <div class="flex items-center gap-40 overflow-x-auto">
        <div class="flex flex-col justify-start" *ngFor="let container of getComponentCountOnLevels({ type: 'physical' })">
          <p class="font-normal text-sm leading-base text-tertiary-text m-0 whitespace-nowrap">
            {{ container.levelBk | storageLevelToCustomerLevelName: true : container.count }}
          </p>

          <twaice-fe-data-display
            class="text-base font-normal leading-lg text-primary-text"
            [value]="container.count"
            numberFormat="1.0-0"
            notAvailableText="-"
            data-test="nav-menu-container-item-value"
          ></twaice-fe-data-display>
        </div>
      </div>
    </div>
  </div>
</div>
